import axios from 'axios';
import {hydrateAndLinkJobTypes} from './JobType';
import Routing from '../../backend-router';

export default {

    async fetchJobTypes() {
        const url = Routing.generate('worker_interface_job_type_tree_quick_job');
        const response = await axios.get(url);
        if (response.status !== 200 || response.data.success !== true) {
            const errorMessage = `response.status !== 200 || response.data.success !== true; response: ${JSON.stringify(response)}`;
            throw new Error(errorMessage);
        }
        const jobTypes = response.data.jobTypes;

        hydrateAndLinkJobTypes(jobTypes);

        return jobTypes;
    },

    async fetchJobTypesWithPartnerPricesForWorker(workerId) {
        const url = Routing.generate('worker_interface_job_type_tree_with_partner_prices', {worker: workerId});
        const response = await axios.get(url);
        if (response.status !== 200 || response.data.success !== true) {
            const errorMessage = `response.status !== 200 || response.data.success !== true; response: ${JSON.stringify(response)}`;
            throw new Error(errorMessage);
        }
        const jobTypes = response.data.jobTypes;

        hydrateAndLinkJobTypes(jobTypes);

        return jobTypes;
    }

}
